import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteKioskMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async kiosk_id => {
      await ApiInstance.post("/dashboard/delete", { kiosk_id }, ENV.kioskBaseURL);
    },
    onSuccess: kiosk_id => {
      const kiosks = typedQueryClient.getQueryData(KioskDashboardQueryKeys.kiosks);
      if (!kiosks) return;

      const kioskIdx = kiosks.findIndex(kiosk => kiosk.id === kiosk_id);
      if (kioskIdx === -1) return;

      typedQueryClient.setQueryData(KioskDashboardQueryKeys.kiosks, kiosks.toSpliced(kioskIdx, 1));
    }
  });
